import React, { useEffect, useState } from 'react';
import { Menu, Sparkles, BookOpen, Plus } from 'lucide-react';
import { useAudio } from '../context/AudioContext';

const hijri = new Intl.DateTimeFormat('ar-SA-u-ca-islamic-umalqura', {
  day: 'numeric',
  month: 'long',
});

/**
 * شريط علوي هادئ.
 *
 * سابقاً كان يحمل شعاراً متدرّجاً وثلاثة أزرار وعنوانين وساعة تتحدث كل
 * ثانية — ضجيج بصري فوق كل شاشة. الآن التاريخ الهجري هو المعلومة الوحيدة
 * الدائمة، والأدوات أيقونات صامتة.
 */
export const Navbar = ({ onToggleSidebar, onOpenTasbeehModal, onOpenDailyVerseModal, onOpenAddModal }) => {
  const { siteSettings, isAdminLoggedIn, isStaff } = useAudio();
  const [today, setToday] = useState(() => new Date());

  // كل دقيقة تكفي لتاريخ يتغيّر مرة في اليوم
  useEffect(() => {
    const id = setInterval(() => setToday(new Date()), 60_000);
    return () => clearInterval(id);
  }, []);

  const tool = (onClick, label, Icon) => (
    <button
      onClick={onClick}
      aria-label={label}
      className="w-9 h-9 rounded-md flex items-center justify-center text-ink-muted hover:text-primary hover:bg-ink/5 transition-colors"
    >
      <Icon className="w-[18px] h-[18px]" aria-hidden="true" />
    </button>
  );

  return (
    <header className="safe-top sticky top-0 z-30 bg-paper/92 backdrop-blur-md">
      <div className="h-14 px-4 flex items-center justify-between gap-3">
        <div className="min-w-0">
          <h1 className="text-sm font-semibold text-ink truncate leading-tight">
            {siteSettings?.siteTitle || 'سكينة'}
          </h1>
          <p className="text-2xs text-ink-muted leading-tight">{hijri.format(today)}</p>
        </div>

        <div className="flex items-center gap-0.5 flex-shrink-0">
          {tool(onOpenDailyVerseModal, 'آية اليوم', BookOpen)}
          {tool(onOpenTasbeehModal, 'السبحة والأذكار', Sparkles)}
          {(isAdminLoggedIn || isStaff) && tool(onOpenAddModal, 'إضافة إذاعة', Plus)}
          <button
            onClick={onToggleSidebar}
            aria-label="القائمة"
            className="w-9 h-9 rounded-md flex items-center justify-center text-ink hover:bg-ink/5 transition-colors"
          >
            <Menu className="w-[18px] h-[18px]" aria-hidden="true" />
          </button>
        </div>
      </div>
    </header>
  );
};
